import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Staff, StaffState } from "./Staff.type";
import { getStaffs, addStaff, updateStaff, deleteStaff } from "./StaffService";

const initialState: StaffState = {
  staffs: [],
  status: "idle",
  error: null,
};

export const fetchStaffsAsync = createAsyncThunk(
  "staffs/fetchStaffs",
  async () => {
    const response = await getStaffs();
    return response;
  }
);

export const createStaffAsync = createAsyncThunk(
  "staffs/createStaff",
  async (user: Staff) => {
    const response: any = await addStaff(user);
    return response.data;
  }
);

export const editStaffAsync = createAsyncThunk(
  "staffs/editStaff",
  async (user: Staff) => {
    const response: any = await updateStaff(user);
    return response.entity;
  }
);

export const removeStaffAsync = createAsyncThunk(
  "staffs/removeStaff",
  async (userId: number) => {
    await deleteStaff(userId);
    return userId;
  }
);

const satffSlice = createSlice({
  name: "staffs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStaffsAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchStaffsAsync.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.staffs = action.payload;
      })
      .addCase(fetchStaffsAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || null;
      })
      .addCase(createStaffAsync.fulfilled, (state, action) => {
        state.staffs.push(action.payload);
      })
      .addCase(editStaffAsync.fulfilled, (state, action) => {
        const index = state.staffs.findIndex(
          (user) => user.id === action.payload.id
        );
        if (index !== -1) {
          state.staffs[index] = action.payload;
        }
      })
      .addCase(removeStaffAsync.fulfilled, (state, action) => {
        state.staffs = state.staffs.filter(
          (staff) => staff.id !== action.payload
        );
      });
  },
});

export default satffSlice.reducer;
